<template>
  <v-app-bar
    id="app-bar"
    absolute
    app
    color="transparent"
    flat
    height="75"
  >
    <v-btn
      class="mr-3 bgColor"
      elevation="1"
      fab
      small
      @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : $emit('input', !value)"
    >
      <v-icon class="icon-color">
        mdi-menu
      </v-icon>
    </v-btn>

    <v-toolbar-title
      class="hidden-sm-and-down font-weight-light"
      v-text="$t($route.name)"
    />

    <v-spacer />
    <v-menu
      bottom
      left
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          class="ml-2"
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
        >
          <v-icon class="icon-color">
            mdi-earth
          </v-icon>
        </v-btn>
      </template>

      <v-list
        :tile="false"
        nav
      >
        <div>
          <app-bar-item
            v-for="(n, i) in languages"
            :key="`item-${i}`"
          >
            <v-list-item-title
              @click="setLanguage(n.code)"
              v-text="n.name"
            />
          </app-bar-item>
        </div>
      </v-list>
    </v-menu>
    <div class="mx-1" />

    <v-btn
      class="ml-2"
      min-width="0"
      text
      @click="goToDashboard"
    >
      <v-icon class="icon-color">
        mdi-view-dashboard
      </v-icon>
    </v-btn>

    <v-menu
      bottom
      left
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          class="ml-2"
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
          @click="getAmountAlerts"
        >
          <v-badge
            color="yellow"
            overlap
            bordered
          >
            <template
              v-slot:badge
            >
              <span>{{ notifications.length }}</span>
            </template>

            <v-icon class="icon-color">
              mdi-bell
            </v-icon>
          </v-badge>
        </v-btn>
      </template>

      <v-list
        :tile="false"
        nav
      >
        <div>
          <app-bar-item
            v-for="(n, i) in notifications"
            :key="`item-${i}`"
          >
            <v-list-item-title
              @click="goToAlerts"
              v-text="n"
            />
          </app-bar-item>
        </div>
      </v-list>
    </v-menu>

    <v-menu
      bottom
      left
      min-width="200"
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          class="ml-2"
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
        >
          <v-icon class="icon-color">
            mdi-account
          </v-icon>
        </v-btn>
      </template>

      <v-list
        :tile="false"
        flat
        nav
      >
        <template v-for="(p, i) in profile">
          <v-divider
            v-if="p.divider"
            :key="`divider-${i}`"
            class="mb-2 mt-2"
          />

          <app-bar-item
            v-else
            :key="`item-${i}`"
            to="/"
          >
            <v-list-item-title
              @click="profileAction(p.title)"
              v-text="p.title"
            />
          </app-bar-item>
        </template>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>
<style scoped>
.yellow{
  background-color: #E2AA12 !important;
    border-color: #E2AA12 !important;
    color: #141414;
}
.icon-color{
  color: #fff !important;
}
  .bgColor{
    background-color: #072347 !important;
  }
</style>
<script>
  // Components
  import { VHover, VListItem } from 'vuetify/lib'

  // Utilities
  import { mapState, mapMutations } from 'vuex'

  // import { repositoryFactory } from '@/api/repositoryFactory'
  // const targetAlertsRespository = repositoryFactory.get('targetAlerts')

  export default {
    name: 'DashboardCoreAppBar',

    components: {
      AppBarItem: {
        render (h) {
          return h(VHover, {
            scopedSlots: {
              default: ({ hover }) => {
                return h(VListItem, {
                  attrs: this.$attrs,
                  class: {
                    'black--text': !hover,
                    'white--text secondary elevation-12': hover,
                  },
                  props: {
                    activeClass: '',
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                }, this.$slots.default)
              },
            },
          })
        },
      },
    },

    props: {
      value: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      notifications: [

      ],
      profile: [
        // { title: 'Profile' },
        // { divider: true },
        { title: 'Log out' },
      ],
      languageCode: 'es',
      languages: [{ name: 'Español', code: 'es' }, { name: 'English', code: 'en' }],
    }),

    computed: {
      ...mapState(['drawer']),
    },
    mounted () {
      // var self = this
      // self.getAmountAlerts()
      // self.polling = setInterval(function () { self.getAmountAlerts() }, 5 * 60 * 1000)
    },
    beforeDestroy () {
      clearInterval(this.polling)
    },
    methods: {
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
      }),
      profileAction (title) {
        if (title === 'Log out') {
          this.$store.commit('LOGOUT')
          this.$router.push('/pages/login')
        }
      },
      setLanguage (code) {
        this.languageCode = code
        this.$i18n.locale = this.languageCode
      },
      getAmountAlerts () {
        // var self = this
        // targetAlertsRespository.getAmountAlerts().then(response => {
        //   self.notifications = []
        //   if (response.data.data.amount > 0) {
        //     self.notifications.push(`Alertas: ${response.data.data.amount}`)
        //   }
        // }).catch(err => {
        //   self.errorMessage = err
        // })
      },
      goToDashboard () {
        this.$router.push({ name: 'dashboard' }).catch(err => {
          // Ignore the vuex err regarding  navigating to the page they are already on.
          if (err.name !== 'NavigationDuplicated') {
            // But print any other errors to the console
            console.error(err)
          }
        })
      },
      goToAlerts () {
        this.$router.push({ name: 'currentAlerts' }).catch(err => {
          // Ignore the vuex err regarding  navigating to the page they are already on.
          if (err.name !== 'NavigationDuplicated') {
            // But print any other errors to the console
            console.error(err)
          }
        })
      },
    },
  }
</script>

<style lang="sass">

</style>
